/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from "react";
// import {Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import Line from "./Charts/Line";
import Bar from "./Charts/Bar";
import {useSelector, useDispatch} from "react-redux";
import {
	ListarPorPeriodo,
	ProjectDetails,
	ListarPorPeriodoDetalles,
	listHistory,
	ListarPorPeriodoDetallesGrafico,
	ListarPorPeriodoGrafico,
	cleanDataChart,
} from "../actions/proyects.actions";
import {Modal, Table} from "react-bootstrap";
import CardsHistory from "./CardsHistory";
// import JSONPretty from "react-json-pretty";

const Operativos = ({CodProyect, setTitleCard, codType = '01', codClassification}) => {
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	const [loading, setLoading] = useState(true);
	const [lgShow, setLgShow] = useState(false);
	const [tableHead, setTableHead] = useState("");
	const [change, setChange] = useState(true);

	useEffect(() => {
		console.log('---- use effect preferences', auth.dateSelected, auth.scaleSelected)
		if (auth.loadingPreferences || !auth.dateSelected || !auth.scaleSelected) {
			return
		}
		
		callChartBar(change)
	}, [auth.dateSelected, auth.loadingPreferences])
	
	const getListHistoryModal = (query) => {
		dispatch(listHistory(CodProyect, "", query, '', auth.scaleSelected, auth.dateSelected));
		setLgShow(true);
	};

	const callChartBar = async (data) => {
		dispatch(cleanDataChart());
		if (!data) {
			if (tableHead === "") {
				dispatch(ListarPorPeriodoGrafico(CodProyect, codClassification, codType, auth.scaleSelected, auth.dateSelected));
			} else {
				dispatch(ListarPorPeriodoDetallesGrafico(
					CodProyect, 
					tableHead, 
					'', 
					codType, 
					auth.scaleSelected, 
					auth.dateSelected,
				));
			}
		} else {
			if (tableHead === "") {
				dispatch(ListarPorPeriodo(
					CodProyect, 
					'', 
					codType,
					auth.dateSelected,
					auth.scaleSelected,
				));
			} else {
				dispatch(ListarPorPeriodoDetalles(CodProyect, tableHead, codType, auth.scaleSelected, auth.dateSelected));
			}
		}
		setChange(data);
	};

	useEffect(() => {
		setLoading(true);
	

		// setTimeout(() => {
		// callChartBar(change);
		dispatch(ProjectDetails(CodProyect, codType, '', auth.scaleSelected, auth.dateSelected));
		setLoading(false);
		// }, 1000);
		// }
		// eslint-disable-next-line
	}, [CodProyect, codClassification, auth.dateSelected, auth.scaleSelected]);

	const queryTable = async (data) => {
		dispatch(cleanDataChart());
		if (tableHead === data) {
			dispatch(ListarPorPeriodo(
				CodProyect, 
				codType,
				'',
				auth.dateSelected,
				auth.scaleSelected,
			));
			setTableHead("");
		} else {
			dispatch(ListarPorPeriodoDetalles(CodProyect, data, codType, auth.scaleSelected, auth.dateSelected));
			setTableHead(data);
		}
	};

	const queryTable2 = async (data) => {
		dispatch(cleanDataChart());
		if (tableHead === data) {
			dispatch(ListarPorPeriodoGrafico(CodProyect, codClassification, codType, auth.scaleSelected, auth.dateSelected));
			setTableHead("");
		} else {
			dispatch(ListarPorPeriodoDetallesGrafico(
				CodProyect, 
				data, 
				'', 
				codType, 
				auth.scaleSelected, 
				auth.dateSelected,
			));
			setTableHead(data);
		}
	};

	return (
		<>
			<Modal
				size="lg"
				show={lgShow}
				onHide={() => setLgShow(false)}
				aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header className="text-center" closeButton>
					<div className="w-100">
						<h4 className="text-center">
							RO {tableHead ? `- ${tableHead}` : null} Período y
							Acumulado (S/.)
						</h4>
					</div>
				</Modal.Header>
				<Modal.Body>
					<CardsHistory head={tableHead}/>
				</Modal.Body>
			</Modal>

			{proyects.graphic && proyects.graphic[0] ? (
				<>
					{change ? (
						<Link
							to="#"
							onClick={() => getListHistoryModal(tableHead)}
						>
							<Line
								data={proyects.graphic}
								className="responsive-chart"
							/>
						</Link>
						
					) : (
						<Link
							to="#"
							// onClick={() => getListHistoryModal(tableHead)}
						>
							<Bar
								data={proyects.graphic}
								className="responsive-chart"
							/>
						</Link>
					)}

					{/* <JSONPretty data={proyects.graphic} /> */}
				</>
			) : (
				<Line data={proyects.graphic} className="responsive-chart" />
			)}

			{proyects.projectDetails && proyects.projectDetails[0] ? (
				<>
					<Table
						striped
						bordered
						hover
						responsive
						size="sm"
						className="mt-3 bg-white"
					>
						<thead>
							{change ? (
								<tr>
									<th className="d-flex justify-content-around headTable">
										<span
											className={change && "chartIcon"}
											onClick={() => callChartBar(true)}
										>
											<i className="fas fa-chart-area"></i>
										</span>

										{change ? (
											<span
												onClick={() =>
													callChartBar(false)
												}
											>
												<i className="far fa-chart-bar"></i>
											</span>
										) : (
											<span
												className="chartIcon"
												onClick={() =>
													callChartBar(false)
												}
											>
												<i className="far fa-chart-bar"></i>
											</span>
										)}
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "HH"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "HH") {
												setTitleCard("");
											} else {
												setTitleCard("HH");
											}
											queryTable("HH");
										}}
									>
										HH
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "MO"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "MO") {
												setTitleCard("");
											} else {
												setTitleCard("MO");
											}

											queryTable("MO");
										}}
									>
										MO (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "MT"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "MT") {
												setTitleCard("");
											} else {
												setTitleCard("MT");
											}
											queryTable("MT");
										}}
									>
										MT (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "EQ"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "EQ") {
												setTitleCard("");
											} else {
												setTitleCard("EQ");
											}
											queryTable("EQ");
										}}
									>
										EQ (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "SC"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "SC") {
												setTitleCard("");
											} else {
												setTitleCard("SC");
											}
											queryTable("SC");
										}}
									>
										SC (S/.)
									</th>
								</tr>
							) : (
								<tr>
									<th className="d-flex justify-content-around headTable">
										<span
											onClick={() => callChartBar(true)}
										>
											<i className="fas fa-chart-area"></i>
										</span>

										<span
											className="chartIcon2"
											onClick={() => callChartBar(false)}
										>
											<i className="far fa-chart-bar"></i>
										</span>
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "HH"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "HH") {
												setTitleCard("");
											} else {
												setTitleCard("HH");
											}
											queryTable2("HH");
										}}
									>
										HH
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "MO"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "MO") {
												setTitleCard("");
											} else {
												setTitleCard("MO");
											}
											queryTable2("MO");
										}}
									>
										MO (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "MT"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "MT") {
												setTitleCard("");
											} else {
												setTitleCard("MT");
											}
											queryTable2("MT");
										}}
									>
										MT (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "EQ"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "EQ") {
												setTitleCard("");
											} else {
												setTitleCard("EQ");
											}
											queryTable2("EQ");
										}}
									>
										EQ (S/.)
									</th>
									<th
										className="change-chart"
										style={{
											background: `${
												tableHead === "SC"
													? "#d8d8d8"
													: "none"
											}`,
										}}
										onClick={() => {
											if (tableHead === "SC") {
												setTitleCard("");
											} else {
												setTitleCard("SC");
											}
											queryTable2("SC");
										}}
									>
										SC (S/.)
									</th>
								</tr>
							)}
						</thead>

						<tbody>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-blue mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Programado
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HH_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_MT_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HM_Programado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_SC_Programado
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-yellow mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Valorizado
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HH_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_MT_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_HM_Valorizado
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Costo_SC_Valorizado
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									<div
										className="bg-aqua mr-2"
										style={{
											width: 15,
											height: 15,
											borderRadius: "50%",
										}}
									></div>{" "}
									Real
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].HH_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_HH_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_MT_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_HM_Real
									)}
								</td>
								<td className="text-right">
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Costo_SC_Real
									)}
								</td>
							</tr>
							<tr>
								<td className="d-flex align-items-center">
									Diferencia (V-R)
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_HH < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0].Diferencia_HH
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_HH < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_HH
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_MT < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_MT
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_HM < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_HM
									)}
								</td>
								<td
									className={`mb-1 ${
										proyects.projectDetails[0]
											.Diferencia_Costo_SC < 0
											? "text-danger"
											: "text-success"
									} text-right`}
								>
									{Intl.NumberFormat("en").format(
										proyects.projectDetails[0]
											.Diferencia_Costo_SC
									)}
								</td>
							</tr>
						</tbody>
					</Table>
				</>
			) : loading ? (
				"Cargando..."
			) : (
				"Sin datos"
			)}
		</>
	);
};

export default Operativos;
